import { AlertsProvider } from '../providers/alertsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_ALERTS_BY_LATLON = new AsyncAction('GET_ALERTS_BY_LATLON');
export const GET_NOTIFICATIONS = new AsyncAction('GET_NOTIFICATIONS');
export const GET_NOTIFICATIONS_STATUS = new AsyncAction('GET_NOTIFICATIONS_STATUS');

export function getAlertsByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh = false) {
    return {
        type: GET_ALERTS_BY_LATLON.base,
        payload: getAlerts(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getAlerts(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    const op = new AlertsProvider(baseUrl, authId, secret);
    return await op.getAlerts(latitude, longitude, stdParameters, verbose, refresh);
}

export function getNotifications(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh = false, emLocationId) {
    return {
        type: GET_NOTIFICATIONS.base,
        payload: getNotificationsAction(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, emLocationId)
    };
}

async function getNotificationsAction(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, emLocationId) {
    const op = new AlertsProvider(baseUrl, authId, secret);
    return await op.getNotifications(latitude, longitude, stdParameters, verbose, refresh, emLocationId);
}

export function getNotificationsStatus(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh = false, emLocationId) {
    return {
        type: GET_NOTIFICATIONS_STATUS.base,
        payload: getNotificationsStatusAction(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, emLocationId)
    };
}

async function getNotificationsStatusAction(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, emLocationId) {
    const op = new AlertsProvider(baseUrl, authId, secret);
    return await op.getNotificationsStatusProvider(latitude, longitude, stdParameters, verbose, refresh, emLocationId);
}
